// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21HKa","placeholdersHeader":"styles_placeholdersHeader__3WUuH","editorStyle":"styles_editorStyle__2Swug","placeholdersBox":"styles_placeholdersBox__5Bj95"};